module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Criar chave"},"en-US":{"title":"Create key"}}')
  delete Component.options._Ctor
}
